import { render, staticRenderFns } from "./LoanDelinquentByProduct.vue?vue&type=template&id=1ddadbd8"
import script from "./LoanDelinquentByProduct.vue?vue&type=script&lang=js"
export * from "./LoanDelinquentByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports